const gameParamater = require('../define/gameParamater').default;
// =============================

const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    // console.log(`### width: ${width} height: ${height}`);
    return {
        width,
        height
    };
}

const applicationStyle = {
    width: getWindowDimensions().width < gameParamater.MAX_WIDTH_PIXEL ? getWindowDimensions().width - 36 : gameParamater.MAX_WIDTH_PIXEL,
    height: getWindowDimensions().height - 36,
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto',
    background: '#223'
}

export default {
    applicationStyle
}